import { ADD_CONTEXT } from '../features/providers/generic';

/**
 * Whether a field value counts as empty for required-field checks.
 * Mirrors how the form treats missing user input (see Input actualRequired).
 */
export function isFieldValueEmpty(field) {
  const { value, type } = field;

  if (value == null || value === false) {
    return true;
  }
  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  if (type === 'checkbox_must_agree') {
    return !Array.isArray(value) || value.length === 0;
  }
  return false;
}

function isRequiredForContext(field, inputContext) {
  const readOnly =
    inputContext === ADD_CONTEXT ? field.add_readonly : field.update_readonly;
  return field.required && !readOnly;
}

/**
 * Ordered list of slugs for required fields that are empty.
 * Order matches the `fields` array (same order as rendered in the form).
 */
export function getOrderedMissingRequiredSlugs(fields, inputContext) {
  if (!Array.isArray(fields)) {
    return [];
  }

  return fields
    .filter(
      (field) =>
        field.display !== false &&
        isRequiredForContext(field, inputContext) &&
        isFieldValueEmpty(field),
    )
    .map((field) => field.slug);
}

export function getFirstMissingRequiredSlug(fields, inputContext) {
  const ordered = getOrderedMissingRequiredSlugs(fields, inputContext);
  return ordered[0] ?? null;
}

export function scrollToOrgField(slug) {
  if (!slug) {
    return;
  }
  const el = document.getElementById(`input-${slug}`);
  if (el && typeof el.scrollIntoView === 'function') {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
